

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IOrderNote} from "@/model/Order/orderInterfaces";
import {DateHelper} from "@/helpers/DateHelper";

  @Component({
    name: 'OONotes',
    components: {
    }
  })
  export default class OONotes extends Vue {

    @Prop()
    protected orderId!: number;
    @Prop()
    protected items!: IOrderNote[];

    protected DateHelper: DateHelper = DateHelper;
    protected showForm: boolean = false;
    protected newComment: string = '';
    protected saving: boolean = false;

    protected isUsersNote(item: IOrderNote): boolean {
      return item.author_user_id == this.$store.getters['authModule/userData'].id;
    }

    protected noteDate(item: IOrderNote): string {
      return DateHelper.relativeTimeFormat(
        item.created_at,
        this.$t('common.today') as string,
        this.$t('common.yesterday') as string,
      );
    }

    protected onAdd() {
      this.showForm = !this.showForm;
      if (this.showForm) {
        this.newComment = '';
      }
    }

    protected onCancel() {
      this.showForm = false;
      this.newComment = '';
    }

    protected async onSubmit() {
      if (!this.newComment.trim() || this.saving) return;
      this.saving = true;
      await this.$store.dispatch('orderModule/addNote', {
        orderId: this.orderId,
        comment: this.newComment.trim(),
      });
      this.saving = false;
      this.showForm = false;
      this.newComment = '';
    }

  }

